import * as React from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { HRQuestionTemplateId } from "../../messages/ObjectIds";
import { Globals } from "../../Globals";


interface GenericTextInputProps {
    hrTextQuestionWithStatus: HRQuestionWithStatus<HRQuestion.TextQuestion | HRQuestion.EmailQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

interface GenericTextInputState {

}

export class GenericTextInput extends React.Component<GenericTextInputProps, GenericTextInputState> {
    constructor(props: GenericTextInputProps) {
        super(props);

        if (props.hrTextQuestionWithStatus.question.answer !== null) {
            return;
        }

        const lastPick = Globals.getAnswerByTemplateId(props.hrTextQuestionWithStatus.question.textId);
        if (lastPick !== null) {
            this.handleChange(lastPick, props.hrTextQuestionWithStatus.question.id);
            props.onBlur(props.hrTextQuestionWithStatus.question.id);
        }
    }

    handleChange(newVal: string, questionId: HRQuestionId) {
        if (newVal.length === 0) {
            this.props.onChange(null, questionId);
        }

        this.props.onChange(newVal, questionId);
    }

    render() {
        const question = this.props.hrTextQuestionWithStatus.question;
        const status = this.props.hrTextQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
               <GenericInputHeader status={status} questionText={question.questionText}/>
                <input
                    required={question.isMandatory}
                    id={HRQuestionTemplateId.unwrap(question.textId)}
                    className={"form-control"}
                    onChange={(e) => this.handleChange(e.target.value, question.id)}
                    placeholder={"Answer here..."}
                    value={question.answer === null ? "" : question.answer}
                    onBlur={() => this.props.onBlur(question.id)}
                />
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericTextInput.tsx